export default {
  username: 'نام کاربر',
  currentPhone: 'شماره فعلی در سامانه',
  newPhone: 'شماره جدید',
  userId: 'شناسه کاربر',
  swapIfExists: 'جابجایی در صورت وجود',
  swapped: 'شماره ها جابجا شد',
  changed: 'شماره کاربر تغییر کرد',
  submit: 'اعمال',
  users: 'کاربران',
  configs: 'تنظیمات',
  adminPanel: 'پیشخوان مدیر',
  systemLogs: 'رخداد‌های‌‌امنیتی',
};
